import paymentType from "./publicPaymentTypes";

const initialState = {
  isLoading: false,
  singlePublicPayment: {},
};

export default function publicPaymentReducer(state = initialState, action) {
  switch (action.type) {
    case paymentType.LOADING_PUBLIC_PAYMENT:
      return {
        ...state,
        isLoading: action.payLoad,
      };


    case paymentType.SINGLE_PUBLIC_PAYMENT:
      return {
        ...state,
        singlePublicPayment: action.payLoad?.data,
      };


    default:
      return state;
  }
}
